<template>
    <div>
        <base-header type="instore" class="pb-5 pt-5 pt-md-8">
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row ml-2 mb-10 regular-header">
                 <div class="col-auto" style="padding: 0px;">
                    <router-link :to="{ name: 'promotions_dashboard_v2'}" >
                        <h6 class="heading-small" style='color: white;'> ⟵   Back to Promo Dashboard </h6>
                    </router-link>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card mb-3">
                            <div class="row no-gutters">
                                <div class="col-md-12">
                                    <div class="card-body pt-0">
                                        <promotions-table :promoType="id" :moduleId="moduleId"></promotions-table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import HTTPRequest from '../../controllers/httpRequest.js';
    import secureStorage from '../../controllers/secureStorage.js';
    import PromotionsTable from '../../views/Promotions/PromotionsTableV2'

    export default {
        components: {
            PromotionsTable
        },
        data() {
            return {
                id: this.$route.params.id.split("|")[0],
                moduleId:this.$route.params.id.split("|")[1]
            }
        },
        mounted: async function () {
            
        },
        computed: {
            ...mapState(['endPoint'])
        },
        methods: {
        }
    }
</script>

<style scoped>
</style>